import React from 'react';
import SelectBox from 'devextreme-react/select-box';
import {
  Chart,
  Series,
  ArgumentAxis,
  CommonSeriesSettings,
  Export,
  Legend,
  Margin,
  Title,
  Subtitle,
  Tooltip,
  Grid
} from 'devextreme-react/chart';
// import fullData from '../../data/social_line.json';
import moment from "moment";
import { SubAccount, ClientsAPI } from 'src/api'


// legend
type Props = {
  client?: SubAccount
}
const SocialNetworks = [
  { value: 'Facebook', name: 'Facebook' },
  { value: 'Instagram', name: 'Instagram' },
  { value: 'Instagram Stories', name: 'Instagram Stories' },
  { value: 'Twitter', name: 'Twitter' },
  { value: 'Yelp', name: 'Yelp' },
  { value: 'YouTube', name: 'YouTube' }
];
type Data = Array<{
    period_index: number;
    month?: number;
    date?: string
}>



class StackedLineSocial extends React.Component<Props> {
  state = {
    data: undefined,
    narrative: undefined
  }
  fetchData = (client: SubAccount) => {
    const params = {
      narrative_assembly_id: "a4a413db-ba3e-11ea-86cf-0e95a518f8f7",
      report_content_id: "6e06762c-8612-4034-8f0b-bf27bca71701",
      sub_account_id: client.id,
      period_index: "1449",
      period_type: "monthly"
    }

    ClientsAPI.getReportData(client, 'social_line.json').then(result => {
      // console.log('done', result)
      this.setState({ data: result.data });
    }).catch(error => {
      // console.log('error', error)
    })

    ClientsAPI.getNarrative(client, params).then(result => {
      // console.log('done', result)
      this.setState({ narrative: result[0] });
    }).catch(error => {
      // console.log('error', error)
    })
  }
  constructor(props: Readonly<{}>) {
    super(props);

  }

  parseMonthData(data: Data|any) {
      const result = data.map((d: { period_index: number; month: number; date: string; }) => {

          const month = (d.period_index % 12) + 1
          const year = 1900 + (d.period_index - (d.period_index % 12)) / 12
          const date = moment(`${month} ${year}`, "M YYYY").format('MMM YYYY')
          d.month = month
          d.date = date
          return d
      })

      return result;
  }

  render() {
    const { data, narrative } = this.state
    const { client } = this.props;
    if (!data && client) {
      this.fetchData(client);
    }

    if (!data) return null;

    return (
      <React.Fragment>
        <Chart
          palette="Bright"
          title="Top Social Network Sessions"
          dataSource={this.parseMonthData(data)}
        >
          <CommonSeriesSettings
            argumentField="date"
            type='line'
          />
          {SocialNetworks.map(function(item: { value: string; name: string; }) {
              return <Series key={item.value} valueField={item.value} name={item.name} />;
            })
          }
          <Margin bottom={20} />
          <ArgumentAxis
            valueMarginsEnabled={false}
            discreteAxisDivisionMode="crossLabels"
          >
            <Grid visible={true} />
          </ArgumentAxis>
          <Legend
            verticalAlignment="bottom"
            horizontalAlignment="center"
            itemTextPosition="bottom"
          />
          <Export enabled={true} />
          <Title text="Top Social Networks">
            <Subtitle text="(Sessions overtime)" />
          </Title>
          <Tooltip enabled={true}
                    color='black'
          />
        </Chart>
        {JSON.stringify(narrative, null, 2)}

      </React.Fragment>
    );
  }


}

export default StackedLineSocial;



// WEBPACK FOOTER //
// ./src/components/ReportComponents/StackedLineSocial.tsx